import { useSimpleFormIteratorItem, TextInput } from "react-admin";
import { useWatch } from "react-hook-form";
import ProfessorInput from "server/components/Fields/ProfessorInput";

const EmployeeOrExternalFields = ({ professorLabel, source = "professors", fullWidth = false }) => {
  const { index } = useSimpleFormIteratorItem();

  const employeeId = useWatch({ name: `${source}.${index}.employeeId` });
  const externalEmployeeNames = useWatch({ name: `${source}.${index}.externalEmployeeNames` });

  return (
    <>
      <ProfessorInput
        source="employeeId"
        label={professorLabel}
        fullWidth
        disabled={!!externalEmployeeNames}
      />
      <TextInput
        source="externalEmployeeNames"
        label="Имена (външни)"
        fullWidth={fullWidth}
        disabled={!!employeeId}
      />
    </>
  );
};

export default EmployeeOrExternalFields;
